const weights = {
  inProgress: 0,
  upComing: 1,
  fullMonth: 2,
  ended: 3,
};
import getMacauDateTime from '@/utils/getMacauDateTime'

export default {
  methods: {
    isDatePass: function(date) {
      if (!date.getTime) return false;

      let today = new Date();
      today.setUTCHours(0, 0, 0, 0);

      return date.getTime() - today.getTime() < 0;
    },
    isEventDatePass: function(date) {
      if (!date 
        || !date.length 
        || typeof date != 'string'
      ) return false;

      let range = date.split(',').pop();
      let lastDate = new Date(range.split('~').pop());
      
      return this.isDatePass(lastDate);      
    },
    parseWhatsonDate: function(r, today) {
      if (today == undefined) {
        today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        today = today.getTime();
      }

      var ranges = (r.eventDate || "").split(",");
      if (ranges[0]) {
        var beforeStart, beforeEnd;
        
        var i;
        for (i in ranges) {
          var range = ranges[i].split("~");
          beforeStart = new Date(range[0]).getTime() - today;
          beforeEnd = new Date(range[1] || range[0]).getTime() + 1000 * 60 * 60 * 24 - today;
          
          if (beforeStart >= 0 || beforeEnd > 0)
            break;
        }
        
        if (i < ranges.length - 1) {
          var range = ranges[ranges.length - 1].split("~");
          beforeEnd = new Date(range[1] || range[0]).getTime() + 1000 * 60 * 60 * 24 - today;
        }
        
        r.daysBeforeStart = beforeStart /= 1000 * 60 * 60 * 24;
        r.daysBeforeEnd = beforeEnd /= 1000 * 60 * 60 * 24;
        
        if (beforeStart > 0)
          r.dateStatus = "upComing";
        else if (beforeEnd < 1) {
          r.dateStatus = "ended";

          let currentTime = getMacauDateTime();
          let currentYear = currentTime.getFullYear();
          let currentMonth = currentTime.getMonth();
          let until = getMacauDateTime(new Date(range[1] || range[0]).getTime() + 1000 * 60 * 60 * 24);
          let untilYear = until.getFullYear();
          let untilMonth = until.getMonth();
          r.hidden = currentYear > untilYear 
            || (currentYear == untilYear && currentMonth > untilMonth)
        } else
          r.dateStatus = "inProgress";
      } else {
        let until = new Date(r.month);
        if (isNaN(until.getTime())) {
          r.dateStatus = "fullMonth"
        } else {
          let currentTime = getMacauDateTime();
          let currentYear = currentTime.getFullYear();
          let currentMonth = currentTime.getMonth();
          until = getMacauDateTime(until.getTime());
          let untilYear = until.getFullYear();
          let untilMonth = until.getMonth();

          r.dateStatus = (currentYear > untilYear 
            || (
              currentYear == untilYear && currentMonth > untilMonth
            )) ? 'ended' : 'fullMonth'

          r.hidden = r.dateStatus == 'ended';
        }
      }

      return {
        ...r
      }
    },
    // Source MGTO:
    sortWhatsonResult: function(results=[], language="zh-hant") {
      let today = new Date();
      today.setUTCHours(0, 0, 0, 0);
      today = today.getTime();

      results.map((r) => this.parseWhatsonDate(r, today));

      results.sort(function(a, b) {
        if (a.dateStatus != b.dateStatus)
          return weights[a.dateStatus] - weights[b.dateStatus];
        
        var delta;
        
        switch (a.dateStatus) {
          case "inProgress":
            delta = a.daysBeforeEnd - b.daysBeforeEnd;
            break;
          case "upComing":
            delta = a.daysBeforeStart - b.daysBeforeStart;
            break;
        }
        
        return delta
              || !!(b.coordinate && b.coordinate[0]) - !!(a.coordinate && a.coordinate[0])
              || (a.name || "").localeCompare(b.name || "", language, {numeric: true, sensitivity: "base"});
      });

      // 3 new properties will be added in each item: dateStatus, daysBeforeStart, daysBeforeEnd
      return results;
    },
    _getDateStatusClass: function(status) {
      return `date-status--${this.$options.filters.toLowerCase(status)}`
    },
    getWhatsonDateStatusText: function(obj) {
      let { 
        dateStatus="", 
        daysBeforeEnd=0, 
        daysBeforeStart=0
      } = obj;
  
      switch (dateStatus) {
        case "": 
          return "";
        case "inProgress":
          return daysBeforeEnd > 0 && daysBeforeEnd <= 5
            ? this.$t(`enf.${daysBeforeEnd > 1 
                ? 'nDaysBeforeEnd' 
                : '1DayBeforeEnd'
              }`, { n: daysBeforeEnd })
            : this.$t('enf.inProgress');
        case "upComing":
          return daysBeforeStart > 0 && daysBeforeStart <= 5
            ? this.$t(`enf.${daysBeforeStart > 1 
                ? 'nDaysBeforeStart' 
                : '1DayBeforeStart'
              }`, { n: daysBeforeStart })
            : this.$t('enf.upComing');
        case "fullMonth":
          return '';
        default: 
          return this.$t(`enf.${dateStatus}`)
      }
    },
    getWhatsonDateStatusClass: function(obj) {
      let { 
        dateStatus="", 
        daysBeforeEnd=0, 
        daysBeforeStart=0
      } = obj;
  
      if (dateStatus == 'inProgress' 
        && daysBeforeEnd > 0 
        && daysBeforeEnd <=5
      ) {
        return this._getDateStatusClass('ending');
      }
  
      if (dateStatus == 'upComing' 
        && daysBeforeStart > 0 
        && daysBeforeStart <=5
      ) {
        return this._getDateStatusClass('starting');
      }
      
      if (dateStatus == 'fullMonth') return '';
      return this._getDateStatusClass(dateStatus);
    },
    getCalendarDateStatusText: function(obj) {
      let {
        showDate, eventDate, datesConfirmed
      } = obj;

      if (this.isEventDatePass(eventDate)) {
        return ''
      };

      return !showDate
          ? this.$t('enf.toBeConfirmed')
          : this.$t(`enf.${datesConfirmed}`)
    },
    getCalendarDateStatusClass: function(obj) {
      let {
        showDate, eventDate, datesConfirmed
      } = obj;
      
      if (this.isEventDatePass(eventDate)) {
        return ''
      };

      if (!showDate) return this._getDateStatusClass('toBeConfirmed')
      if (!datesConfirmed || datesConfirmed == 'confirmed') return '';
      return this._getDateStatusClass(datesConfirmed)
    },
    sortCalendarEvent: function(enfs) {
      const _makeSureYear = (s, y) => {
        if (!Array.isArray(s[y])) s[y] = Array.from(Array(12), () => []);
      };
      
      let groupEnfs = enfs.reduce((s, e) => {
        let ranges = (e.eventDate || "").split(",");
        if (!ranges[0]) return s;
        e.startDate = new Date(ranges[0].split("~")[0]);

        let occurMonth = new Set();
        let shadow = false;
        ranges.forEach(r => {
          let range = r.split('~');
          let startDate = new Date(range[0]);
          let endDate = new Date(range[1] || range[0]);
          let startYear = startDate.getFullYear();
          let startMonth = startDate.getMonth();
          let endYear = endDate.getFullYear();
          let endMonth = endDate.getMonth();
          let countingY = startYear;
          _makeSureYear(s, countingY);
          for (
            let countingM = startMonth; 
            countingY * 100 + countingM <= endYear * 100 + endMonth;
            countingM ++
          ) {
            if (countingM > 11) {
              countingM = 0;
              countingY ++;
              _makeSureYear(s, countingY);
            }
            if (!occurMonth.has(countingY + '-' + countingM)) {
              s[countingY][countingM].push(shadow ? { ...e, shadow } : e);
              shadow = true;
              occurMonth.add(countingY + '-' + countingM)
            }
          };
        })
        return s;
      },  {})
      Object.keys(groupEnfs).map(y => {
        return groupEnfs[y].map(m => m.sort((a, b) => a.startDate - b.startDate));
      });

      return groupEnfs;
    }
  },
}